import { LiaRupeeSignSolid } from "react-icons/lia";

import {
  HeadingTitle,
  Button,
} from "../../../components/shared/index";
import { useNavigate } from "react-router-dom";
const CartOrderSummary = ({
  styles,
  subtotal,
  shippingCost,
  tax,
  totalAmount,
  onButtonClick,
  loading,
  selectedCount,
}) => {
    const navigate = useNavigate();

  return (
    <div className={styles.summarySection}>

      {/* =================================================
          TITLE
      ================================================= */}

      <HeadingTitle
        style={styles.summaryHeading}
        text="Order Summary"
      />

      {/* =================================================
          SUBTOTAL
      ================================================= */}

      <div className={styles.summaryRow}>

        <div>
          <span>Subtotal</span>

          <div
            className={
              styles.summaryItemCount
            }
          >
            ({selectedCount} item
            {selectedCount !== 1
              ? "s"
              : ""}
            )
          </div>
        </div>

        <span>
          <LiaRupeeSignSolid size={17} />

          {Number(subtotal || 0).toLocaleString(
            "en-IN"
          )}
        </span>

      </div>

      {/* =================================================
          SHIPPING
      ================================================= */}

      <div className={styles.summaryRow}>

        <span>Shipping</span>

        <span
          className={
            shippingCost === 0
              ? styles.freeShipping
              : ""
          }
        >
          {shippingCost === 0
            ? "FREE"
            : `₹${Number(
                shippingCost
              ).toLocaleString("en-IN")}`}
        </span>

      </div>

      {/* =================================================
          TAX
      ================================================= */}

      {Number(tax || 0) > 0 && (
        <div
          className={styles.summaryRow}
        >
          <span>Tax</span>

          <span>
            <LiaRupeeSignSolid
              size={17}
            />

            {Number(tax).toLocaleString(
              "en-IN"
            )}
          </span>
        </div>
      )}

      {/* =================================================
          SAVINGS
      ================================================= */}

      {Number(subtotal || 0) > 0 && (
        <div
          className={
            styles.savingsMessage
          }
        >
          ✓ You are getting the best
          available price
        </div>
      )}

      {/* =================================================
          TOTAL
      ================================================= */}

      <div
        className={`${styles.summaryRow} ${styles.totalRow}`}
      >

        <strong>Total Amount</strong>

        <strong>
          <LiaRupeeSignSolid
            size={19}
          />

          {Number(
            totalAmount || 0
          ).toLocaleString("en-IN")}
        </strong>

      </div>

      {/* =================================================
          CHECKOUT BUTTON
      ================================================= */}

      <Button
        title={
          loading
            ? "Processing..."
            : "Continue to Payment"
        }
        onHandler={onButtonClick}
        style={styles.checkoutBtn}
        disabled={loading}
      />

      {/* =================================================
          TERMS
      ================================================= */}

    <p className={styles.checkoutTerms}>
  By continuing, you agree to our{" "}
  <button
    type="button"
    className={styles.termsLink}
    onClick={() => navigate("/terms-and-conditions")}
  >
    Terms & Conditions
  </button>{" "}
  and{" "}
  <button
    type="button"
    className={styles.termsLink}
    onClick={() => navigate("/privacy-policy")}
  >
    Privacy Policy
  </button>
  .
</p>

    </div>
  );
};

export default CartOrderSummary;